(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ActivitiesNewTaskDialogController', ActivitiesNewTaskDialogController);

    ActivitiesNewTaskDialogController.$inject = ['$uibModalInstance'];

    function ActivitiesNewTaskDialogController($uibModalInstance) {
        var vm = this;

        vm.clear = clear;

        vm.openCalendar = openCalendar;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateDueDateTask = false;
        vm.datePickerOpenStatus.dateReminder = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
